<template lang="pug">
section
  s-page-title(
    :previous='true',
    :title='id ? "Редактирование комплекса" : "Добавление комплекса"',
    :subtitle='id ? item.complex_name : "Жилой комплекс"'
  )
  v-card(:key='item.id')
    v-tabs(v-model='active', color='dark', slider-color='primary')
      v-tab Комплекс
      v-tab-item(:transition='false', :reverse-transition='false')
        v-container(grid-list-xl, fluid)
          v-layout(wrap)
            v-flex(xs12)
              s-publish-date-status(:errors='errors', :model='item', label="Открыть в МП и на Корп сайте")
            v-flex(xs6)
              v-checkbox(
                v-model='item.show_about_project'
                label='Включить режим предпросмотра "О проекте" по прямой ссылке'
                color='primary'
              )              
            v-flex(xs6)
              v-checkbox(
                v-model='item.excursion_enabled'
                label='Проводяться экскурсии по ЖК'
                color='primary'
              )              
            v-flex(xs12, sm3)
              s-region-picker(
                :error='errors.has("region_id")',
                :errors-messages='errors.first("region_id")',
                v-model='item.region_id'
              )
            v-flex(xs12, sm3)
              v-text-field(
                :error='errors.has("complex_code")',
                :error-messages='errors.first("complex_code")',
                :disabled='!!item.id',
                v-model='item.complex_code',
                label='Код комплекса'
              )
            v-flex(xs12, sm3)
              s-complex-type-picker(
                :error='errors.has("complex_type_id")',
                :error-messages='errors.first("complex_type_id")',
                v-model='item.complex_type_id'
              )
            v-flex(xs12, sm3)
              s-date-picker(
                :validator='errors',
                v-model='item.due_date',
                label='Срок ввода/сдачи',
                name='due_date'
              )
            v-flex(xs12, sm4)
              v-text-field(
                :error='errors.has("complex_name")',
                :error-messages='errors.first("complex_name")',
                v-model='item.complex_name',
                label='Название комплекса'
              )
            v-flex(xs12, sm8)
              v-text-field(
                :error='errors.has("complex_full_name")',
                :error-messages='errors.first("complex_full_name")',
                v-model='item.complex_full_name',
                label='Полное название комплекса'
              )
            v-flex(xs6, sm4)
              v-text-field(
                v-model='item.objects_count',
                label='Количество обьектов в ЖК'
              )
            v-flex(xs12, sm4)
              v-select(
                :error='errors.has("state_id")',
                :error-messages='errors.first("state_id")',
                :items='states',
                label='Статус строительства',
                item-value='id',
                item-text='name',
                v-model='item.state_id'
              )
            v-flex(xs12, sm4)
              v-select(
                :error='errors.has("ext_guid")',
                :error-messages='errors.first("ext_guid")',
                :items='projectsList',
                label='Комплекс из 1с',
                item-value='guid',
                item-text='name',
                v-model='item.ext_guid'
              )
            v-flex(xs12, sm6)
              v-text-field(
                v-model='item.dvizh_uuid',
                label='UUID комлекса в ДВИЖ'
              )
            v-flex(xs12, sm6)
            v-flex(xs12, sm6)
              s-developers-picker(
                :error='errors.has("developer_id")',
                :error-messages='errors.first("developer_id")',
                v-model='item.developer_id'
              )
            v-flex(xs12, sm6)
              v-select(
                :items='managementCompList',
                label='Управляющая компания',
                item-value='id',
                item-text='name',
                v-model='item.management_company_id'
              )
            v-flex(xs12, sm4)
              v-text-field(
                v-model='item.city',
                label='Город (населенный пункт)'
              )
            v-flex(xs12, sm8)
              v-text-field(v-model='item.address', label='Адрес строкой')
            v-flex(xs6)
              v-text-field(
                v-model='item.lat',
                label='Координаты: широта (latitude)'
              )
            v-flex(xs6)
              v-text-field(
                v-model='item.lon',
                label='Координаты: долгота (longitude)'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.avatar_url',
                @remove='onRemoveAvatar',
                v-model='item.avatar',
                label='Фото комплекса'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.logo_url',
                @remove='onRemoveLogo',
                v-model='item.logo',
                label='Логотип комплекса'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.icon_url',
                @remove='onRemoveIcon',
                v-model='item.icon',
                label='Мини-логотип для перечня'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.full_complex_plan_url',
                @remove='onRemoveComplexPlan',
                v-model='item.full_complex_plan',
                label='План застройки ЖК'
              )

      v-tab Настройки
      v-tab-item(:transition='false', :reverse-transition='false')
        v-container(grid-list-xl, fluid)
          v-layout(wrap)
            v-flex(xs6)
              v-text-field(
                :error='errors.has("tips_green")',
                :error-messages='errors.first("tips_green")',
                v-model='item.tips_green',
                label='Зеленая метка'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("tips_grey")',
                :error-messages='errors.first("tips_grey")',
                v-model='item.tips_grey',
                label='Серая метка'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("phone")',
                :error-messages='errors.first("phone")',
                v-model='item.phone',
                label='Номер телефона'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("phone_html")',
                :error-messages='errors.first("phone_html")',
                v-model='item.phone_html',
                label='Номер телефона для отображения (html)'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("youtube_review")',
                :error-messages='errors.first("youtube_review")',
                v-model='item.youtube_review',
                label='Ссылка на видеообзор формата: https://www.youtube.com/embed/ХХХХХХХХХХ'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("default_meta.h1")',
                :error-messages='errors.first("default_meta.h1")',
                v-model='item.default_meta.h1',
                label='META.H1'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("default_meta.title")',
                :error-messages='errors.first("default_meta.title")',
                v-model='item.default_meta.title',
                label='META.title'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("default_meta.description")',
                :error-messages='errors.first("default_meta.description")',
                v-model='item.default_meta.description',
                label='META.description'
              )
            v-flex(xs12, sm4)
              v-text-field(
                :error='errors.has("complex_settings.genplan.url")',
                :error-messages='errors.first("complex_settings.genplan.url")',
                v-model='item.complex_settings.genplan.url',
                label='Ссылка на папку с тайлами генплана. НЕ ЗНАЕШЬ? НЕ ТРОГАЙ!'
              )
            v-flex(xs12, sm4)
              v-text-field(
                :error='errors.has("complex_settings.genplan.url_night")',
                :error-messages='errors.first("complex_settings.genplan.url_night")',
                v-model='item.complex_settings.genplan.url_night',
                label='Ссылка на тайлы НОЧНОГО генплана. Тайлы должны совпадать с дневным!'
              )
            v-flex(xs12, sm4)
              v-text-field(
                :error='errors.has("complex_settings.genplan.mask")',
                :error-messages='errors.first("complex_settings.genplan.mask")',
                v-model='item.complex_settings.genplan.mask',
                label='Маска для тайлов!'
              )
            v-flex(xs3)
              v-text-field(
                :error='errors.has("complex_settings.genplan.width")',
                :error-messages='errors.first("complex_settings.genplan.width")',
                v-model='item.complex_settings.genplan.width',
                label='Ширина ГП'
              )
            v-flex(xs3)
              v-text-field(
                :error='errors.has("complex_settings.genplan.height")',
                :error-messages='errors.first("complex_settings.height")',
                v-model='item.complex_settings.genplan.height',
                label='Высота ГП'
              )
            v-flex(xs3)
              v-text-field(
                :error='errors.has("complex_settings.genplan.minZoom")',
                :error-messages='errors.first("complex_settings.genplan.minZoom")',
                v-model='item.complex_settings.genplan.minZoom',
                label='Min Zoom'
              )
            v-flex(xs3)
              v-text-field(
                :error='errors.has("complex_settings.genplan.maxZoom")',
                :error-messages='errors.first("complex_settings.maxZoom")',
                v-model='item.complex_settings.genplan.maxZoom',
                label='Max Zoom'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.top_view_url',
                @remove='onRemoveTopView',
                v-model='item.top_view',
                label='Вид сверху (для страницы "Солнце")'
              )
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.scheme_url',
                @remove='onRemoveScheme',
                v-model='item.scheme',
                label='Схема генплана как на Промо (194x194)'
              )              
            v-flex(xs12, sm4)
              s-image-upload(
                :src='item.icon_map_url',
                @remove='onRemoveIconMap',
                v-model='item.icon_map',
                label='Иконка ЖК на карте'
              )                            
      v-tab Для МП
      v-tab-item(:transition='false', :reverse-transition='false')
        v-container(grid-list-xl, fluid)
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                :error='errors.has("complex_settings.inspection_info.location")',
                :error-messages='errors.first("complex_settings.inspection_info.location")',
                v-model='item.complex_settings.inspection_info.location',
                label='Место встречи для осмотра квартиры'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("complex_settings.inspection_info.documents")',
                :error-messages='errors.first("complex_settings.inspection_info.documents")',
                v-model='item.complex_settings.inspection_info.documents',
                label='Документы, необходимые для осмотра'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("slogan")',
                :error-messages='errors.first("slogan")',
                v-model='item.description.slogan',
                label='Слоган'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("annotation")',
                :error-messages='errors.first("annotation")',
                v-model='item.description.annotation',
                label='Краткая аннотация'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("description")',
                :error-messages='errors.first("description")',
                v-model='item.description.description',
                label='Описание ЖК'
              )
            v-flex(xs12)
              s-file-upload(
                v-model='item.buklet',
                :file='item.buklet_url',
                :record-id='item.id',
                :parseResponse='(v) => v.hash',
                @remove-success='onRemoveBuklet',
                label='Презентация ЖК'
              )
      template(v-if='item.id')
        v-tab Генплан МП
        v-tab-item(:transition='false', :reverse-transition='false')
          simple-genplan(:id='item.id')
      //- template(v-if='id')
      //-   v-tab Уведомления
      //-   v-tab-item(:transition='false', :reverse-transition='false')
      //-     notifications(:emails='item.emails', :complexId='id')
      v-tab Генплан
      //- TODO: вынести это в отдельный компонент, слишком много стало строк
      v-tab-item(:transition='false', :reverse-transition='false')
        v-data-table(
          :hide-actions='true',
          :items='genplan.objects',
          :headers=`[
            { text: "#ID", sortable: false, width: '0%' },
            { text: "Название", sortable: false },
            { text: "Метка", sortable: false, align: "center" },
            { text: "Обводка", sortable: false, align: "center" },
            { text: "", width: "100%", sortable: false },
            { text: "", width: "0%", sortable: false }
          ]`
        )
          template(slot='items', slot-scope='props')
            tr.with-pointer
              td {{ props.item.id }}
              td.wrapless {{ props.item.name }}
              td.center
                v-icon(v-if='props.item.point', color='primary') done
              td.center
                v-icon(v-if='props.item.polygon', color='primary') done
              //- распорка, не ну а чо )
              td
              td.text-xs-right.wrapless.crud-tools
                v-btn(icon, @click='clearObjectPath(props.item.id)')
                  v-icon(small) delete
                v-btn(icon, @click.stop='genplan.opened = true')
                  v-icon(small) edit
        //- Редактор генплана
        genplan-modal(
          v-model='genplan',
          @complete='saveGenplan',
          ref='genplanModal'
        )
      template(v-if='id')
        v-tab Метки
        v-tab-item(:transition='false', :reverse-transition='false')
          placemarks(:id='id', :object='item', :active='active')
      template(v-if='id')
        v-tab Социальные сети
        v-tab-item(:transition='false' :reverse-transition='false')
          v-container(grid-list-xl fluid)
            v-layout(wrap)
              v-flex(xs12 sm6)
                v-text-field(
                  v-model='item.social.vk'
                  label='ВКонтакте'
                )
              v-flex(xs12 sm6)
                v-text-field(
                  v-model='item.social.tg'
                  label='Telegram'
                )
              v-flex(xs12 sm6)
                v-text-field(
                  v-model='item.social.max'
                  label='MAX'
                )
              v-flex(xs12 sm6)
                v-text-field(
                  v-model='item.social.rut'
                  label='RuTube'
                )
              //- v-flex(xs12 sm6)
              //-   v-text-field(
              //-     v-model='item.social.fb'
              //-     label='FaceBook'
              //-   )
              //- v-flex(xs12 sm6)
              //-   v-text-field(
              //-     v-model='item.social.twi'
              //-     label='Twiter'
              //-   )
              //- v-flex(xs12 sm6)
              //-   v-text-field(
              //-     v-model='item.social.inst'
              //-     label='Instagram'
              //-   )

              //- v-flex(xs12 sm6)
              //-   v-text-field(
              //-     v-model='item.social.you'
              //-     label='YouTube'
              //-   )
    v-card-actions.large(v-if='actionsShown')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading',
        @click.native='onSave',
        color='primary',
        depressed
      ) Сохранить
</template>

<script>
import http from '@/http'
import Placemarks from './Placemarks.vue'
import SimpleGenplan from './SimpleGenplan.vue'
import Notifications from './Notifications'
import { mapActions, mapGetters, mapState } from 'vuex'
import { createFormData } from '@/utils'
import { GenplanModal } from '@/modules/genplan'

// Индексы вкладок, на которых нужно скрыть кнопки
// Сохранить/Отмена
const actionsHiddenTabs = [3, 4, 5]

export default {
  props: ['id'],

  components: {
    GenplanModal,
    Notifications,
    Placemarks,
    SimpleGenplan,
  },

  data: function () {
    return {
      avatar: null,
      logo: null,
      icon: null,
      item: {
        default_meta: {},
        complex_settings: {
          genplan: {},
          inspection_info: {
            location: '',
            documents: '',
          },
        },
        social: {},
        description: {},
      },
      active: 0,
      genplan: {
        options: {
          minZoom: 0,
          url: null,
          width: 0,
          height: 0,
        },
        opened: false,
        objects: [],
      },
      // complex_settings: {},
      states: [
      {
          id: 'draft',
          name: 'Черновик',
        },{
          id: 'soon',
          name: 'Скоро в продаже',
        },
        {
          id: 'inprogress',
          name: 'Строится (в продаже)',
        },
        {
          id: 'finished',
          name: 'Реализован',
        },
      ],
      placements: [],
    }
  },

  async mounted() {
    this.managmentCompFetch()
    this.getProjectsList()

    if (this.id) {
      try {
        this.item = (
          await this.fetchSingle({
            id: this.id,
            config: {
              params: {
                show_info: true,
              },
            },
          })
        ).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки карты')
      }
    }

    // Модель для редактирования генплана
    if (this.id && this.item.complex_settings) {
      const { genplan } = this.item.complex_settings
      this.genplan.options = {
        ...genplan,
        url: genplan.url + genplan.mask,
        url_night: genplan.url_night ? genplan.url_night + genplan.mask : null,
      }
      if (!this.item.complex_settings.inspection_info)
        this.item.complex_settings.inspection_info = {
          location: null,
          documents: null,
        }

      const response = await http.get(`/complexes/${this.id}/paths`)
      this.genplan.objects = response.data
    }
  },

  methods: {
    async onSave() {
      // сохранение всего остального
      let data = createFormData(this.item)
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data,
          })
        } else {
          await this.create({ data })
        }
        this.$root.showSnack('Комплекс сохранен')
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    onRemoveIcon() {
      this.item.icon = null
    },
    onRemoveComplexPlan() {
      this.item.full_complex_plan = null
    },
    
    onRemoveIconMap() {
      this.item.icon_map = null
    },

    onRemoveLogo() {
      this.item.logo = null
    },

    onRemoveAvatar() {
      this.item.avatar = null
    },

    onRemoveTopView() {
      this.item.top_view = null
    },
    onRemoveScheme() {
      this.item.scheme = null
    },    

    onRemoveBuklet() {
      this.item.buklet = null
      this.item.buklet_url = null
    },

    createFormData() {
      let data = new FormData()

      Object.keys(this.item).forEach((key) => {
        data.append(key, this.item[key])
      })

      return data
    },

    async clearObjectPath(objectID) {
      if (await this.$confirm('Очистить обводку и метку для объекта?')) {
        try {
          await http.delete(`/complexes/objects/${objectID}/paths`)
          this.$root.showSnack('Обводка удалена')
          const response = await http.get(`/complexes/${this.id}/paths`)
          this.genplan.objects = response.data
          // обновим генплан
          const genplan = this.$refs.genplanModal.getGenplanInstance()
          genplan && genplan.reinit()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления обводки')
        }
      }
    },

    async saveGenplan() {
      if (await this.$confirm('Сохранить изменения?')) {
        let objects = this.genplan.objects
        try {
          await http.patch(`/complexes/${this.id}/paths`, { objects })
          this.$root.showSnack('Генплан сохранен')
          this.genplan.opened = false
        } catch (e) {
          this.$root.showSnack('Ошибка сохранения генплана')
        }
      }
    },

    ...mapActions('objects/complexes', [
      'fetchSingle',
      'update',
      'create',
      'getProjectsList',
    ]),

    ...mapActions('objects/management_comp', {
      managmentCompFetch: 'fetchList',
    }),
  },

  computed: {
    // Не будем показывать кноки Сохарнить/Отмена
    // на некоторых вкладках
    actionsShown() {
      return !actionsHiddenTabs.includes(this.active)
    },

    ...mapGetters('objects/complexes', ['isLoading', 'projectsList']),
    ...mapState('objects/complexes', ['projectsList']),
    ...mapGetters('objects/management_comp', { managementCompList: 'list' }),
  },
}
</script>

<style scoped>
.yamap {
  height: 320px;
}
</style>
